import {apiClient} from "constants/Clients";

export const updateApprovalStatus = key => ({
  hookName: 'updateApprovalStatus',
  request: (approvalStatusId, approvalStatus) => apiClient.updateApprovalStatus({id: approvalStatusId, ...approvalStatus}),
  key,
});